import { connect } from 'react-redux'
import LPMenu from './lp-menu'
import { getPresentation } from '../../../../../stores/presentation/presentation.selectors'

const mapStateToProps = state => {
  const presentation = getPresentation(state)
  return {
    pending: !presentation,
    presentationTitle: presentation && presentation.title,
    presentationLo: presentation && presentation.lesson_overview,
    premiumRestricted: presentation && presentation.policy.premium_restricted,
    presentation
  }
}

export default connect(
  mapStateToProps,
  null
)(LPMenu)
